export const FILTER_COLLAPSE_STATE_KEYS = {
  CATEGORY: 'category',
  CATEGORY_LIST: 'category-list',
  PROMOTION: 'promotion',
  PRICE: 'price'
};
